/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   isValidCenter
 */

import { isNumber } from '@zcode/utils'

import type { MaybeNullCoords } from '../../types'
export const isValidCenter = (center: MaybeNullCoords | undefined) => {
  const { lat, lng } = center || {}

  return isNumber(lat) && isNumber(lng)
}
